export default __webpack_public_path__ + "static/media/musala-soft.cc908978.png";